import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import { Genre } from '../../../app/_models/Genre';
import { LightShowTrackService } from '../../../app/_services/track.service';
import { DialogService } from '../../../app/_services/dialog.service';
import { tap, takeUntil, mergeMap } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';

@Component({
  templateUrl: './genre-edit-modal.component.html',
  styleUrls: ['./genre-edit-modal.component.css']
})

export class GenreEditModalComponent implements OnInit, OnDestroy {
  public genres: Genre[];

  public genreName: string;

  public loading = true;

  public invalidName = false;

  private onDestroy$: Subject<void> = new Subject();

  constructor(private trackService: LightShowTrackService,
              private dialogService: DialogService,
              private viewRef: ViewContainerRef) { }

  ngOnInit() {
    this.loadGenres().subscribe();
  }

  addGenre() {
    if (this.genreName && this.genreName.trim().length >= 2) {
      this.loading = true;

      const genre: Genre = {
        name: this.genreName
      };

      this.trackService.addGenre(genre)
        .pipe(
          takeUntil(this.onDestroy$),
          tap(
            () => {
              this.genreName = '';
              this.invalidName = false;
              this.loading = false;
              this.trackService.genresUpdated.emit();
            },
            () => {
              this.loading = false;
            }
          ),
          mergeMap(() => this.loadGenres())
        ).subscribe();
    } else {
      this.invalidName = true;
    }
  }

  removeGenre(genre: Genre) {
    this.loading = true;
    this.trackService
      .deleteGenre(genre.genreId)
      .pipe(
        takeUntil(this.onDestroy$),
        tap(
          () => {
            this.loading = false;
            this.trackService.genresUpdated.emit();
          },
          () => {
            this.loading = false;
            this.dialogService.alert('Error', 'Unable to delete genre', this.viewRef);
          }
        ),
        mergeMap(() => this.loadGenres())
      ).subscribe();
  }

  private loadGenres(): Observable<Genre[]> {
    return this.trackService.getAllGenres().pipe(
      takeUntil(this.onDestroy$),
      tap(
        genres => {
          this.genres = genres;
          this.loading = false;
        },
        () => {
          this.dialogService.alert('Error', 'Unable to load genres', this.viewRef);
          this.loading = false;
        }
      )
    );
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
